export var GLOBAL_FORM_REPOSITORY = 'GLOBAL_FORM_REPOSITORY';